
export default function ErrorTemplate() {
    return (
        <div className="error-template-wrapper py-5">
            <div className="error-template d-flex align-items-center justify-content-center flex-column">
                <div className={"h6 color-flint-red"}>Rendering error</div>
            </div>
        </div>
    )
}